/*
 * @Author: 李才人
 * @Date: 2021-07-20 13:41:53
 * @LastEditors: 李才人
 * @LastEditTime: 2021-07-20 14:06:12
 * @FilePath: \m_saas_business_admin\src\dataBase\authCodeMap\assets.ts
 * @Description: 资产模块code码
 */
export const assets = {
  asset_overview: "asset_overview",
  dataAnalysis: "dataAnalysis",
  dataAnalysis_user: "dataAnalysis_user",
  dataAnalysis_user_export1: "dataAnalysis_user_export1",
  dataAnalysis_user_export2: "dataAnalysis_user_export2",
  dataAnalysis_user_export3: "dataAnalysis_user_export3",
  dataAnalysis_user_export4: "dataAnalysis_user_export4",
  dataAnalysis_user_index: "dataAnalysis_user_index",
  dataAnalysis_user_index_export: "dataAnalysis_user_index_export",
  dataAnalysis_user_prop: "dataAnalysis_user_prop",
  dataAnalysis_user_prop_export: "dataAnalysis_user_prop_export",
  dataAnalysis_content: "dataAnalysis_content",
  dataAnalysis_content_export1: "dataAnalysis_content_export1",
  dataAnalysis_content_export2: "dataAnalysis_content_export2",
  dataAnalysis_content_interactive: "dataAnalysis_content_interactive",
  dataAnalysis_content_visit: "dataAnalysis_content_visit"
};